require('babel-polyfill');

import { default as ConfirmModal } from 'components/confirm';
window.React = require('react');
window.ReactDOM = require('react-dom');

window.AccessControlSearch = require('components/manage/access_control_search');
window.BetterErrorPagesGetStarted = require('components/better_error_pages/get_started');
window.ComponentToggler = require('components/component_groups');
window.ComponentStatuses = require('components/manage/pages/components/component_statuses');
window.ConfirmModal = ConfirmModal;
window.HostHelper = require('components/manage/pages/host_helper');
window.ExceedingAllocationsDashboard = require('components/manage/admin/exceeding_allocations/exceeding_allocations_dashboard');
window.ConsentHub = require('atlassian/consent_hub');
window.ImportSubscriberForm = require('components/manage/pages/notifications/import_subscriber_form');
window.IncidentsSearchField = require('components/manage/incidents_search_field');
window.IncidentTemplates = require('components/manage/incident_templates/incident_templates');
window.IncidentTemplateForm = require('components/manage/incident_templates/incident_template_form');
window.ItemsSelector = require('components/items_selector/items_selector');
window.ModifyUser = require('components/manage/organizations/modify_user');
window.OrganizationPages = require('components/manage/admin/organizations/pages');
window.PageAccessUsersForm = require('components/manage/page_access_users/form');
window.PageAccessSearchField = require('components/manage/page_access_search_field');
window.PageSubscription = require('components/manage/admin/pages/subscription');
window.NotificationsSubscriberManager = require('components/manage/notifications/notifications_subscriber_manager');
window.ResendConfirmationLink = require('components/resend_confirmation_link');
window.SingleSignOnForm = require('components/manage/pages/single_sign_on_form');
window.SsoMetrics = require('components/manage/shared/sso_metrics');
window.StrideConversations = require('components/manage/stride_conversations');
window.StrideConversationsAdminInfo = require('components/manage/stride_conversations_admin_info');
window.SubscribersSearchField = require('components/manage/subscribers_search_field');
window.UnsubscribeButton = require('components/manage/unsubscriber');

window.ManageSubscription = require('containers/status/manage');
window.BackfillDateTimePicker = require('components/backfill_date_time_picker');



// WEBPACK FOOTER //
// ./app/javascript/packs/components.js